import {useMemberStore} from '~/store/member'

/**
 * admin만 접근 가능한 페이지에 대한 미들웨어
 */
export default defineNuxtRouteMiddleware(() => {
  const isAdmin = useMemberStore().isAdmin
  if (!isAdmin) {
    return navigateTo('/')
  }
})
